var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreasureChest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 56,
    viewBox: "0 0 73 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.167 0H16.167C7.29199 0 0.166992 7.25 0.166992 16V48C0.166992 52.5 3.66699 56 8.16699 56H64.167C68.542 56 72.167 52.5 72.167 48V16C72.167 7.25 64.917 0 56.167 0ZM12.167 52H8.16699C5.91699 52 4.16699 50.25 4.16699 48V32H12.167V52ZM12.167 28H4.16699V16C4.16699 10.875 7.41699 6.5 12.167 4.75V28ZM56.167 52H16.167V32H24.167V38C24.167 41.375 26.792 44 30.167 44H42.167C45.417 44 48.167 41.375 48.167 38V32H56.167V52ZM28.167 38V22C28.167 21 29.042 20 30.167 20H42.167C43.167 20 44.167 21 44.167 22V38C44.167 39.125 43.167 40 42.167 40H30.167C29.042 40 28.167 39.125 28.167 38ZM56.167 28H48.167V22C48.167 18.75 45.417 16 42.167 16H30.167C26.792 16 24.167 18.75 24.167 22V28H16.167V4H56.167V28ZM68.167 48C68.167 50.25 66.292 52 64.167 52H60.167V32H68.167V48ZM68.167 28H60.167V4.75C64.792 6.5 68.167 10.875 68.167 16V28ZM36.167 36C37.167 36 38.167 35.125 38.167 34V26C38.167 25 37.167 24 36.167 24C35.042 24 34.167 25 34.167 26V34C34.167 35.125 35.042 36 36.167 36Z",
    fill: "#FFFFF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasureChest);
export default __webpack_public_path__ + "static/media/treasure-chest.33cb1a972b0b6e9baa03a665293e9571.svg";
export { ForwardRef as ReactComponent };